// extracted by mini-css-extract-plugin
export default {"locationDetails":"styles_locationDetails__qq87C","locationName":"styles_locationName__epig0","locationAddress":"styles_locationAddress__F4g7Y"};